import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectBase } from './base'

export const selectDraftWidget = createSelector(
  selectBase,
  base => base.draftWidget
)

// TODO (jscheel): It's possible to rewrite selectCurrentWidgetSettings to figure
// return the draft widget, if we are in the create wizard, but for now it was
// clearer to have two completely separate selectors.
export const selectDraftWidgetSettings = createSelector(
  selectDraftWidget,
  draft => draft?.settings || emptyObj
)

// NOTE (jscheel): This is a bit of a fake-out selector. We don't really care
// too much about validation on the widget, because pretty much everything
// works with defaults, so it's difficult to get into an invalid state. However,
// we want to do at least a few checks to make sure that the "next" button should
// be enabled. Because all the widget settings forms are controlled via
// withFormFields, we don't have a great way for sharing the validation state
// around yet. If we end up having more complex validation cases, we can address
// figuring out how best to bridge withFormFields with the store at that point.
export const selectDraftWidgetValid = createSelector(
  selectDraftWidget,
  widget => {
    return !!widget?.name
  }
)

export const selectIsCreatingDraftWidget = createSelector(
  selectBase,
  base => base.isCreatingDraftWidget
)
